import React, { useState, useEffect } from "react";
import { makeRequest } from "../../axios";
import Loader from "../../UI/Loader/Loader";
import СoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import classes from "./PassTest.module.css";
import { TestType } from "../../types/test"; 

const TIMER_INITIAL_VALUE = 1500;

type Props = {
  test: TestType;
  updateTimer: () => void;
  switchTest?: boolean;
  skipTest: () => void;
  testsNumber: number;
  passTestsNumber: number;
  sendAnswer: ({ answer }: {answer: string}) => void;
  setFinishWithoutAnswers: () => void;

}

const PassTest: React.FC<Props> = ({
  test,
  updateTimer, 
  switchTest,
  skipTest,
  testsNumber,
  passTestsNumber,
  sendAnswer,
  setFinishWithoutAnswers,
}: Props) => {



  
  const sendDataHandler = (e: React.MouseEvent) => {
    const answerTarget: any =  e.target
    sendAnswer({ answer: answerTarget.children[0].value });
  };

  function getZero(num: number) {
    if (num < 10) {
      return "0" + num;
    } else {
      return num;
    }
  }


  

  const [timer, setTimer] = useState<number | null>(TIMER_INITIAL_VALUE);


  useEffect(() => {

    makeRequest.get('/test/timer').then(res => {
      setTimer(res.data)
    })

    if (timer !== 0) {
      const timeoutFinish = setInterval(() => {
        setTimer((prev) => {
          if(typeof prev == 'number') {

            if (prev > 0) {
              updateTimer()
              return --prev
            }
          }
          
          if (prev === 0)
            setFinishWithoutAnswers();
          return null;
        });
      }, 1000);
      return () => clearInterval(timeoutFinish);
    }

  }, []);

  const valuesAnswers: string[] = Object.values(JSON.parse(test.answers));

  const answers = valuesAnswers?.map((el: string, id) => (
    <div key={id}>
      <div className={classes.test_pass__response}>
        <span onClick={sendDataHandler}>{el} <input type="hidden" value={el}/></span> {el}
        
      </div>
    </div> 
  ));

  return (
    <div className={classes.test_pass__wrapper}>
      <div style={{ position: "relative" }}>
        {switchTest && ( 
          <СoveredBackground color='darkcyan'>
            <Loader  white={true}/>
          </СoveredBackground>
        )}
        <div className={classes.test_pass__question}> {test.question} </div>
        <hr />
        <form>
          <div className={classes.test__pass__answer}>{answers}</div>
        </form>
 
        <input type="hidden" value={test.id} />

        {!(testsNumber - passTestsNumber === 1) && (
          <button
            type="submit"
            className={classes.test__pass__btn_pass}
            onClick={skipTest}
          >
            Пропустить
          </button>
        )}
      </div>
      <hr />
      <div className={classes.test__pass__footer} style={{marginTop: 20}}>
        <div className={classes.test__pass__number}>
          Ответ получен на {passTestsNumber}/{testsNumber}
        </div>
        <div className={classes.test__pass__timer}>
          {typeof timer === "number" && getZero(Math.trunc((timer / 60) % 60))+":"+ getZero(timer % 60)}
        </div>
      </div>
    </div>
  );
};

export default PassTest;
